module.exports = __webpack_public_path__ + "files/326b19e07d03d6fe3b469a1f0e759733.png";